import { useEffect } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const useConfirmSuccess = (onClose: ICloseEvent['onClose']) => {
    const { user, lang } = useStore();
    const key = useKeyDown();

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                onClose();
                break;
        }
    };

    useEffect(() => {
        return () => {
            user.resetConfirmed();
            user.resetPasswordConfirmed();
            user.resetEmail();
            user.resetConfirmationErr();
        };
    }, []);
    useEffect(() => {
        handleKey(key);
    }, [key]);

    return {
        store: user,
        lang,
    };
};

export default useConfirmSuccess;
